import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		onBoardRoot: {
			flexDirection: 'column',
			display: 'flex',
			width: '100%',
			maxWidth: '100%',
			alignItems: 'center',
		},
		jobContainer: {
			top: '90px',
			bottom: theme.spacing(6),
			width: '100%',
			height: 'auto',
			maxWidth: '670px',
			padding: '0px 10px',
		},
		imgUploadBtn: {
			background: theme.palette.grey[300],
			textTransform: 'none',
			margin: '20px 0px',
			width: '220px',
			fontSize: '12px',
			fontWeight: 500,
			padding: '3px',
		},
		cvUploadBtn: {
			background: 'transparent',
			textTransform: 'none',
			margin: '20px 0px',
			width: '220px',
			fontSize: '12px',
			fontWeight: 500,
			padding: '3px',
		},
		uploadNewBtn: {
			fontWeight: 700,
			fontSize: 10,
			// backgroundColor: theme.palette.secondary.main,
			textTransform: 'none',
		},
		deleteIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		deleteRootElement: {
			position: 'absolute',
			top: '8px',
			right: '8px',
		},
		btnsContainer: {
			display: 'flex',
			alignItems: 'center',
			marginTop: '10px',
		},
		nextBtn: {
			marginLeft: 'auto',
			textTransform: 'none',
		},
		imgWrap: {
			position: 'relative',
			display: 'flex',
			justifyContent: 'center',
			margin: '30px 0px',
			[theme.breakpoints.down('xs')]: {
				margin: '15px 0px 0px 0',
			},
			'& img': {
				margin: '30px 0px',
			},
			border: '1px solid #ebebeb',
			borderRadius: '8px',
			paddingLeft: '10px',
			paddingRight: '10px',
		},
		uploadCvWrap: {
			position: 'relative',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			flexFlow: 'column',
			margin: '30px 0px',
			'& img': {
				margin: '30px 0px',
			},
			background: '#ebebeb',
			borderRadius: '8px',
			paddingLeft: '10px',
			paddingRight: '10px',
		},
		fileName: {
			color: theme.palette.grey[800],
		},
		cvWrap: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'row',
			margin: '20px 0px',
			'& img': {
				margin: '30px 0px',
			},
			background: '#ebebeb',
			borderRadius: '8px',
			paddingLeft: '10px',
			paddingRight: '10px',
			height: '80px',
		},
		avatarImg: {
			marginLeft: 'auto',
		},
		userAvatarImg: {
			maxHeight: 300,
			alignSelf: 'center',
			borderRadius: '50%',
		},
		buttonsContainer: {
			flex: 1,
			alignSelf: 'stretch',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			maxHeight: 48,
			'& > button': {
				flex: 1,
				height: theme.spacing(6),
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				color: '#ffffff',
				fontSize: 18,
			},
		},
		cancelButton: {
			fontWeight: 500,
			backgroundColor: theme.palette.grey[300],
		},
		saveButton: {
			fontWeight: 700,
			backgroundColor: theme.palette.secondary.main,
		},
		preview: {
			padding: 16,
			overflow: 'auto',
			[theme.breakpoints.down('sm')]: {
				padding: 8,
			},
		},
		error: {
			'& .fr-placeholder': {
				color: 'rgba(255,0,0,0.5)!important',
			},
			'& $preview': {
				color: 'rgba(255,0,0,0.5)!important',
			},
		},
		labelTextField: {
			color: theme.palette.grey[800],
		},
		labelField: {
			color: theme.palette.grey[800],
		},
		labelFieldError: {
			color: theme.palette.secondary.main,
		},
		finalStepTitle: {
			color: '#000000',
			fontWeight: 600,
			fontSize: '18px',
			margin: '30px 0',
		},
		salaryRangeItem: {
			paddingTop: '0px !important',
		},
		input: {
			color: '#000000',
		},
		textError: {
			'& ::placeholder': {
				color: 'rgba(255,0,0,1)!important',
			},
		},
		activeContainer: {
			position: 'relative',
			// margin: '0 -15px',
			margin: `${theme.spacing(1)}px 0 0 0`,
			padding: 0,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			flex: 1,
			alignSelf: 'stretch',
			cursor: 'pointer',
			'& .fr-box': {
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				// height: '100%',
				flexGrow: 1,
				'& .fr-element': {
					paddingTop: 0,
				},
				'& .fr-placeholder': {
					// paddingTop: '1em!important',
					// paddingBottom: '1em!important',
				},
				'& > .fr-toolbar': {
					// border: 'none',
					boxShadow: 'none',
					background: 'transparent',
				},
				'& > .fr-wrapper': {
					flexGrow: 1,
					boxShadow: 'none!important',
					background: 'transparent',
				},
			},
			[theme.breakpoints.down('sm')]: {
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: '#ffffff',
				zIndex: 100,
			},
		},
		editorRoot: {
			display: 'flex',
			flexDirection: 'column',
			// height: '380px',
			marginTop: '30px',
		},
		editorContainer: {
			border: `1px solid ${theme.palette.grey[200]}`,
		},
		selectInputRoot: {
			'&::before': {
				border: 'none',
			},
		},
		textField: {
			width: '100%',
		},
		chip: {
			margin: 2,
			cursor: 'pointer',
			fontWeight: 500,
			'&:hover, &:focus': {
				backgroundColor: '#e1e1f4 !important',
				color: '#1B1A7C',
			},
		},
		divider: {
			margin: '5px 0px',
		},
		chipActive: {
			background: '#e1e1f4',
			color: '#1B1A7C',
		},
		chipInactive: {
			color: '#1B1A7C',
		},
		fieldContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		selectionContainer: {
			display: 'flex',
			flexDirection: 'row',
			marginTop: '5px',
		},
		titleField: {
			marginTop: '30px',
			paddingBottom: '0px !important',
		},
		jobReviewContainer: {
			position: 'relative',
			width: '100%',
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'column',
		},
		progressBarContainer: {
			margin: '15px 0px',
			width: '100%',
			maxWidth: '670px',
		},
		progressBarContainerText: {
			textAlign: 'center',
			marginBottom: 10,
		},
		requiredField: {
			marginLeft: 5,
			fontSize: 10,
			fontStyle: 'italic',
			color: 'inherit',
		},
		textFieldInput: {
			'&::placeholder': {
				color: theme.palette.grey[800],
				fontFamily: 'Open Sans, sans-serif !important',
			},
		},
		helperTextInfo: {
			fontStyle: 'italic',
		},
		mt20: {
			marginTop: 20,
		},
		mb10: {
			marginBottom: 10,
		},
		container: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		formControl: {
			margin: theme.spacing(1),
			width: '97%',
		},
		overflowYVisible: {
			overflowY: 'visible',
		},
	})
